﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catTiposDatosServicios } from "../../Categorias y Estados/catTiposDatosServicios";
import { ListasValores } from "../../ListasValores/ListasValores";

const columns = () =>
(
    {
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.PK, prompt: 'Servicio ID' }),
        c_paso_id: new EntityColumn<string>({ name: 'c_paso_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Paso ID' }),
        i_orden: new EntityColumn<number>({ name: 'i_orden', type: 'int', flags: c.Edit, prompt: 'Orden' }),
        bt_requerido: new EntityColumn<boolean>({ name: 'bt_requerido', type: 'bit', flags: c.Edit, prompt: 'Requerido' }),
        vc_descripcionpaso: new EntityColumn<string>({ name: 'vc_descripcionpaso', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        vc_observacionespaso: new EntityColumn<string>({ name: 'vc_observacionespaso', type: 'varchar', flags: c.Edit, prompt: 'Observaciones' }),
        c_tiposdatosservicios_id: new EntityColumn<string>({ name: 'c_tiposdatosservicios_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tipo de dato' }),
        c_listavalores_id: new EntityColumn<string>({ name: 'c_listavalores_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Lista de valores' }),
        bt_unsolovalor: new EntityColumn<boolean>({ name: 'bt_unsolovalor', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Unico valor' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        seco_brwStandard: { name: 'seco_brwStandard', keyMappings: { c_paso_id: 4 } }
    }
)

const lookups = () =>
(
    {
        'TiposDatosServicios': {
            name: 'TiposDatosServicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposDatosServicios(client, parentKeys)
        },
        'ListaValores': {
            name: 'ListaValores',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ListasValores(client, parentKeys)
        },

    }
)

const procs = () =>
(
    {
        seco_getOrdenSiguiente: { name: 'seco_getOrdenSiguiente' }
    }
)


export class ServiciosConfiguracionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();

    constructor() {
        super('ServiciosConfiguracion');
    }
}